import {getElement} from "./utils/getElement";

const initLoginPage = () => {
    const registerSwitch = getElement('.js-register')
    const loginSwitch = getElement('.js-back-to-login')
    const loginForm = getElement('.js-login-form')
    const registerForm = getElement('.js-register-form')

    if (!registerSwitch || !loginSwitch || !loginForm || !registerForm) {
        return null;
    }

    registerSwitch.addEventListener('click', () => {
        loginForm.style.display = 'none'
        registerForm.style.display = 'block'
    })

    loginSwitch.addEventListener('click', () => {
        registerForm.style.display = 'none'
        loginForm.style.display = 'block'
    })
}

export {initLoginPage}
